import React from 'react';
import PropTypes from 'prop-types';

export const documentLinkPropTypes = {
    link: PropTypes.string,
    text: PropTypes.string.isRequired,
    target: PropTypes.string,
    icon: PropTypes.func,
    onClick: PropTypes.func
};